import React, { Component } from "react";
import { Button, Form, Modal } from "semantic-ui-react";
import Swal from "sweetalert2";

export default class CloseJobModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dbmNo: null,
    };
  }

  alertDialog = (title, text, icon) => {
    Swal.fire({
      title: title,
      text: text,
      icon: icon,
    }).then((res) => {
      if (res.isConfirmed && icon === "success") {
        return this.props.isClose();
      }
    });
  };

  onUpdateMaintenance = async () => {
    const { dbmNo } = this.state;
    if (dbmNo == null) {
      return this.alertDialog(
        "Error!",
        "กรุณากรอกหมายเลขเอกสารเบิกจ่าย",
        "error"
      );
    }

    const data = {
      dbmNo: dbmNo,
      dbmBy: "manager",
      state: "finish",
      isComplete: 1,
    };

    console.log(data);

    if (dbmNo != null) {
      this.alertDialog("Success!", "อนุมัติปิดเรื่องสำเร็จ", "success");
    } else {
      this.alertDialog("Error!", "อนุมัติปิดเรื่องไม่สำเร็จ", "error");
    }
  };

  render() {
    const { dbmNo } = this.state;
    return (
      <Modal
        // dimmer="blurring"
        size="tiny"
        open={this.props.isOpen}
        onClose={() => this.props.isClose()}
      >
        <Modal.Header style={{ fontFamily: "Kanit" }}>
          อนุมัติปิดเรื่อง
        </Modal.Header>
        <Modal.Content
          style={{
            marginTop: "2%",
            fontSize: "16px",
            borderRadius: "0",
            // textAlign: "center",
          }}
        >
          <div style={{ padding: "2% 5%" }}>
            <Form>
              <Form.Field>
                <label style={{ fontSize: "16px", paddingBottom: "1%" }}>
                  หมายเลขเอกสารเบิกจ่าย
                </label>
                <input
                  type="text"
                  placeholder="หมายเลขเอกสารเบิกจ่าย"
                  style={{ fontFamily: "Kanit" }}
                  value={dbmNo}
                  onChange={(e) => this.setState({ dbmNo: e.target.value })}
                />
              </Form.Field>
            </Form>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              marginTop: "2%",
              marginBottom: "5%",
            }}
          >
            <Button
              basic
              style={{
                fontSize: "16px",
                fontFamily: "Kanit",
              }}
              negative
              onClick={() => this.props.isClose()}
            >
              ยกเลิก
            </Button>
            <Button
              basic
              style={{
                fontSize: "16px",
                fontFamily: "Kanit",
              }}
              positive
              onClick={() => this.onUpdateMaintenance()}
            >
              ตกลง
            </Button>
          </div>
        </Modal.Content>
      </Modal>
    );
  }
}
